import React, { useState, useEffect } from 'react';
import './solution.css';
import Administration from './administration';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import AdmissionPatientComponent from './admission';
import PlanTraitement from './traitment';
import CalculFrais from './totalfee';
import PatientDossier from './summaryhospitalization';
import GestionLits from './affectation';
import Payment from './makepayment';
import DechargePatient from './patientdischarge';
import SurveillanceQuotidienne from './surveillance';
import SuiviMedicalComplet from './surveillanceComplet';
import SuiviPostSortie from './dechargerecomandation';
import { toast } from 'react-toastify';

// Composant principal gérant la navigation entre les frames
function App() {
  const [admissions, setAdmisive] = useState([]);
  const [currentFrame, setCurrentFrame] = useState(1);
  const [selectedPatient, setSelectedPatient] = useState(null);

  // Fonction de callback pour mettre à jour le dossier du patient
  const updatePatientDossier = (data) => {
    if (selectedPatient) {
      setSelectedPatient(prev => ({ ...prev, ...data }));
    }
  };

  // Callback pour naviguer directement vers la page Dossier (frame 10)
  const openDossier = (patient) => {
    setSelectedPatient(patient);
    setCurrentFrame(10);
  };

  const goToNext = (destination) => {
    if (destination) {
      setCurrentFrame(destination);
    } else {
      setCurrentFrame(prev => prev + 1);
    }
  };

  const goToPrevious = () => {
    if (currentFrame === 10) {
      setCurrentFrame(1);
    } else if (currentFrame > 1) {
      setCurrentFrame(prev => prev - 1);
    }
  };

  const handleSaveDossier = () => {
    toast.error("Dossier patient sauvegardé !");
    setCurrentFrame(1);
  };

  let content;
  switch (currentFrame) {
    case 1:
      content = (
        <AdmissionPatientComponent
          onNext={goToNext}
          onBack={null}
          admissions={admissions}
          setAdmisive={setAdmisive}
          onOpenDossier={openDossier}
        />
      );
      break;
    case 2:
      content = <GestionLits onNext={goToNext} onBack={goToPrevious} patientId={selectedPatient} />;
      break;
    case 3:
      content = <PlanTraitement onNext={goToNext} onBack={goToPrevious} updatePatientDossier={updatePatientDossier} patientId={selectedPatient} />;
      break;
    case 4:
      content = <SurveillanceQuotidienne onNext={goToNext} onBack={goToPrevious} updatePatientDossier={updatePatientDossier} patientId={selectedPatient} />;
      break;
    case 5:
      content = (
        <SuiviMedicalComplet
          onNext={goToNext}
          onBack={goToPrevious}
          updatePatientDossier={updatePatientDossier}
          patientId={selectedPatient}
        />
      );
      break;
    case 6:
      content = <CalculFrais onNext={goToNext} onBack={goToPrevious} patientData={selectedPatient} />;
      break;
    case 7:
      content = <DechargePatient onNext={goToNext} onBack={goToPrevious} patientData={selectedPatient} />;
      break;
    case 8:
      content = <Payment onNext={goToNext} onBack={goToPrevious} patientData={selectedPatient} />;
      break;
    case 9:
      content = <SuiviPostSortie onNext={goToNext} onBack={goToPrevious} patientData={selectedPatient} />;
      break;
    case 10:
      content = <PatientDossier onNext={goToNext} patientData={selectedPatient} onBack={goToPrevious} onSave={handleSaveDossier} />;
      break;
    default:
      content = <div>Fin du parcours</div>;
  }

  return (
    <div className="app">
      

      {content}
    </div>
  );
}

export default App;
